import React from "react";

export default function TableTempurture() {
  return <div className="box-table-temperature"></div>;
}
